export const server = 'https://conduit.suyash.io';



/** WEBPACK FOOTER **
 ** ./src/util/constants.js
 **/